import React, { Component, createRef, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { chunk } from '../../utils/utils'
import MediaQuery from 'react-responsive'
import { withAuth } from '../AuthContext'
import Notification from '../Utils/Notification'
import { withSearch } from '../SearchContext'
import MapComponent from './MapComponent'
import BookingSection from './BookingSection/BookingSection'
import BookingSectionConfirm from './BookingSectionConfirm'
import Button from '../Utils/Button'
import ImageGallery from 'react-image-gallery'
import { strLimit } from '../../utils/utils'
import VerifyModal from '../ui/modal/VerifyModal'


class Place extends Component {
  constructor(props) {
    super(props)
    this.state = {
      place: {
        user: {},
        gallery: [],
        languages: [],
        galleryImages: [],
      },
      filters: [],
      guests: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
      ],
      isMarkerShown: false,
      gallery: [],
      amenities: [],
      coordinates: {},
      showMap: false,
      dates: {
        label: `Please choose`,
        value: '',
      },
      bookingForm: {
        startDate: null,
        endDate: null,
        guests: null,
        message: '',
        placeId: '',
        userId: '',
        filters: [],
        nights: 1,
        fee: null,
      },
      loading: false,
      bookingRequest: {},
      bookingFormErrors: {},
      modalIsOpen: false,
      modalText: '',
    }

    this.scrollToRef = createRef()
    this.scrollToMobileRef = createRef()

    this.handleGuestChange = this.handleGuestChange.bind(this)
    this.handleMessageChange = this.handleMessageChange.bind(this)
    this.handleScrollToBookingRequest =
      this.handleScrollToBookingRequest.bind(this)
    this.handleScrollToMobileBookingRequest =
      this.handleScrollToMobileBookingRequest.bind(this)
    this.handleBookingRequest = this.handleBookingRequest.bind(this)
    this.handleApply = this.handleApply.bind(this)
    this.validateErrors = this.validateErrors.bind(this)
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props

    // Extract only the numeric ID from the params.id, excluding query parameters
    const placeId = params.id.split('?')[0]

    this.setState((prevState) => ({
      bookingForm: {
        ...prevState.bookingForm,
        placeId,
      },
    }))

    axios
      .get(`/api/place/${placeId}`)
      .then((response) => {
        const place = response.data.data
        this.setState({
          place,
          coordinates: place.coordinates,
          showMap: true,
        })

        // Process gallery and amenities into chunks
        const gallery = chunk(place.photos, 2)
        this.setState({ gallery })
        const amenities = chunk(place.amenities, 2)
        this.setState({ amenities })
      })
      .catch((error) => {
        console.log('Request failure: ', error)
      })

    axios.get(`/api/bookings/validate/${placeId}`).then((response) => {
      this.setState({ bookingRequest: response.data })
    })

    this.delayedShowMarker()
  }

  delayedShowMarker() {
    setTimeout(() => {
      this.setState({ isMarkerShown: true })
    }, 3000)
  }

  handleMarkerClick() {
    this.setState({ isMarkerShown: false })
    this.delayedShowMarker()
  }

  handleGuestChange({ value }) {
    this.setState((prevState) => {
      const { guests, ...rest } = prevState.bookingFormErrors
      prevState.bookingForm = {
        ...prevState.bookingForm,
        guests: value,
      }
      prevState.bookingFormErrors = rest
      return prevState
    })
  }

  handleMessageChange({ target }) {
    this.setState((prevState) => {
      return {
        bookingForm: {
          ...prevState.bookingForm,
          message: target.value,
        },
      }
    })
  }

  handleScrollToBookingRequest() {
    this.scrollToRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  handleScrollToMobileBookingRequest() {
    this.scrollToMobileRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  openModal = (text) => {
    this.setState({
      modalIsOpen: true,
      modalText: text,
    })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  handleBookingRequest(e) {
    e.preventDefault()

    const { startDate, endDate, guests, message, placeId, nights, fee } =
      this.state.bookingForm

    if (!this.props.auth.loggedIn) {
      this.props.history.push('/loginsignup')
      return
    }

    const requestData = {
      startDate,
      endDate,
      guests,
      message,
      placeId,
      nights,
      fee,
      hostId: this.props.auth.user.id,
      filters: this.props.location.state
        ? this.props.location.state.filters
        : '',
    }

    const headers = {
      'Content-Type': 'application/json',
    }

    axios
      .post('/api/bookings', { ...requestData }, headers)
      .then((response) => {
        if (response.data.success) {
          if (
            response.data.message === 'pending_profile' ||
            response.data.message === 'pending_id'
          ) {
            this.openModal()
          } else {
            Notification({
              type: 'success',
              message: 'Your request has been sent!',
            })
            this.props.history.push(
              `/place/${this.state.bookingForm.placeId}/request-sent`,
              { bookingRequest: response.data.data }
            )
          }
        } else {
          this.handleErrors(response.data.message)
        }
      })
      .catch((error) => {
        if (error.response) {
          // Handle backend validation errors or exceptions
          const { message, errors } = error.response.data
          this.handleErrors(message, errors)
        } else {
          Notification({
            type: 'error',
            message:
              'There was an issue sending your request. Please try again later.',
          })
        }
      })
  }

  handleErrors(message, errors = null) {
    if (message === 'overbooked') {
      Notification({
        type: 'info',
        message:
          'Your chosen dates include unavailable days. Please select a different date range.',
      })
    } else if (message === 'request_exists') {
      Notification({
        type: 'info',
        message: 'You already have a pending request for this property.',
      })
    } else if (message === 'Your account needs to be fully validated before proceeding. Please complete your profile verification.') {
      this.setState({
        modalIsOpen: true,
      })
    } else if (errors) {
      // Display validation errors
      Object.keys(errors).forEach((field) => {
        Notification({
          type: 'error',
          message: errors[field].join(', '), // Show validation messages
        })
      })
    } else {
      Notification({
        type: 'error',
        message: message || 'An unexpected error occurred.',
      })
    }
  }

  validateErrors() {
    let errors = {
      dates: false,
      guests: false,
    }
    const { startDate, endDate, guests } = this.state.bookingForm
    const today = new Date()
    today.setHours(0, 0, 0, 0) // Normalize today to midnight

    console.log('startDate:', startDate, 'endDate:', endDate)

    // Date validation
    if (!startDate || !endDate) {
      this.setState((prevState) => ({
        bookingFormErrors: {
          ...prevState.bookingFormErrors,
          dates: 'Please choose your trip dates',
        },
      }))
      errors.dates = true
    } else {
      const parsedStartDate = new Date(startDate)
      const parsedEndDate = new Date(endDate)

      if (parsedStartDate < today || parsedEndDate < today) {
        this.setState((prevState) => ({
          bookingFormErrors: {
            ...prevState.bookingFormErrors,
            dates: 'Dates cannot be in the past',
          },
        }))
        errors.dates = true
      } else {
        const diffInDays =
          (parsedEndDate - parsedStartDate) / (1000 * 60 * 60 * 24)
        if (diffInDays < 1) {
          this.setState((prevState) => ({
            bookingFormErrors: {
              ...prevState.bookingFormErrors,
              dates: 'The booking must be for at least one full night.',
            },
          }))
          errors.dates = true
        } else {
          this.setState((prevState) => {
            const { dates, ...rest } = prevState.bookingFormErrors
            return { bookingFormErrors: rest }
          })
          errors.dates = false
        }
      }
    }

    // Guests validation
    if (!guests || guests <= 0) {
      this.setState((prevState) => ({
        bookingFormErrors: {
          ...prevState.bookingFormErrors,
          guests: 'Please enter the number of travelers',
        },
      }))
      errors.guests = true
    } else {
      this.setState((prevState) => {
        const { guests, ...rest } = prevState.bookingFormErrors
        return { bookingFormErrors: rest }
      })
      errors.guests = false
    }

    // Return validation result
    return !errors.dates && !errors.guests
  }

  handleApply(e, picker) {
    this.setState((prevState) => {
      const updatedBookingForm = {
        ...prevState.bookingForm,
        startDate: new Date(new Date(picker.startDate).setHours(10, 0, 0, 0)),
        endDate: new Date(new Date(picker.endDate).setHours(20, 0, 0, 0)),
        nights: picker.endDate.diff(picker.startDate, 'days'),
      }

      const updatedBookingFormErrors = { ...prevState.bookingFormErrors }
      delete updatedBookingFormErrors.dates // Clear date-related errors

      const updatedDates = {
        label: `${picker.startDate.format('DD MMM YYYY')} - ${picker.endDate.format('DD MMM YYYY')}`,
        value: '',
      }

      return {
        bookingForm: updatedBookingForm,
        bookingFormErrors: updatedBookingFormErrors,
        dates: updatedDates,
      }
    })
  }

  render() {
    const customSelect = {
      control: (base, state) => ({
        ...base,
        background: '#f5f6f7',
        border: 'none',
        borderRadius: '0px',
        flexWrap: 'nowrap',
        height: '52px',
      }),
    }

    const modalStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      },
    }

    const proceedToPayment =
      this.state.bookingRequest.status === 'approved' &&
      this.state.bookingRequest.paymentStatus !== 'succeeded'
    const IsPendingBookingRequest =
      this.state.bookingRequest.status === 'pending'
    const IsPendingVerificationBookingRequest =
      this.state.bookingRequest.status === 'pending-verification'

    const placeUser = this.state.place.user

    return (
      <Fragment>
        <section
          id="place"
          className="contact-wrapper main-wrapper"
          ref={this.scrollToMobileRef}
        >
          <div className="beta-badge-corner">BETA</div>
          <div className="container">
            {proceedToPayment && (
              <Fragment>
                <MediaQuery maxWidth={776}>
                  <div className="col-12 col-md-4 mb-3">
                    <BookingSectionConfirm
                      layout={'vertical'}
                      currency={this.state.place.currency}
                      bookingRequest={this.state.bookingRequest}
                      bookingForm={this.state.bookingForm}
                    />
                  </div>
                </MediaQuery>
                <MediaQuery minWidth={777}>
                  <BookingSectionConfirm
                    layout={'horizontal'}
                    currency={this.state.place.currency}
                    bookingRequest={this.state.bookingRequest}
                    bookingForm={this.state.bookingForm}
                  />
                </MediaQuery>
              </Fragment>
            )}
            <div className="row pb-4 title">
              <div className="col-12 col-md-6">
                <h1 className="font-all-round font-weight-600 font-size-34 text-black pb-3">
                  {this.state.place.user.forename}'s place
                </h1>
                <span className="font-open-sans font-weight-600 font-size-16">
                  <img src="/images/icons/location.svg" alt="" />{' '}
                  {this.state.place.location}
                </span>
                <br className="d-md-none pb-3" />
                <span
                  className="pl-md-4 font-open-sans font-weight-600 font-size-16"
                  dangerouslySetInnerHTML={{
                    __html: `<img src="/images/icons/tag.svg" alt=""/> ${this.state.place.currency}${this.state.place.price} - per night`,
                  }}
                />
              </div>
              <div className="col-12 py-2 mt-auto">
                {!proceedToPayment &&
                  (IsPendingBookingRequest ||
                    (IsPendingVerificationBookingRequest && (
                      <div className="btn btn-gray font-open-sans font-size-14 font-weight-700 text-white float-md-right w-md-100 w-50 pending">
                        Your request is pending...
                      </div>
                    )))}
              </div>
            </div>
          </div>
          <MediaQuery maxWidth={776}>
            <div className="container mb-4">
              <div className="row">
                <ResultUserCard
                  userPhoto={placeUser.photo}
                  userName={placeUser.forename}
                  location={this.state.place.location}
                  introduction={placeUser.introduction}
                  id={placeUser.id}
                />
                {proceedToPayment ? (
                  <div
                    className="container"
                    onClick={this.handleScrollToMobileBookingRequest}
                  >
                    <Button color="green" classes="w-100">
                      <span
                        className="w-100"
                        dangerouslySetInnerHTML={{
                          __html: `Pay ${this.state.place.currency}${(this.state.bookingForm.nights * +this.state.bookingRequest.fee).toFixed(2)} to confirm booking`,
                        }}
                      />
                    </Button>
                  </div>
                ) : (
                  !IsPendingBookingRequest &&
                  !IsPendingVerificationBookingRequest && (
                    <BookingSection
                      ref={this.state.place.id}
                      place={this.state.place}
                      startDate={new Date()}
                      endDate={new Date()}
                      pickerDates={this.state.dates}
                      handleGuestChange={this.handleGuestChange}
                      handleMessageChange={this.handleMessageChange}
                      handleBookingRequest={this.handleBookingRequest}
                      scrollToRef={this.scrollToRef}
                      guests={this.state.guests}
                      customSelect={customSelect}
                      handleApply={this.handleApply}
                      nights={this.state.bookingForm.nights}
                      fee={this.state.bookingForm.fee}
                      bookingFormErrors={this.state.bookingFormErrors}
                      validateErrors={this.validateErrors}
                      modalStyles={modalStyles}
                    />
                  )
                )}
              </div>
            </div>
          </MediaQuery>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-8">
                <div className="row">
                  <div className="col-12 row no-gutters images d-flex justify-content-center">
                    <ImageGallery
                      items={this.state.place.galleryImages}
                      additionalClass={'place-gallery'}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          Description
                        </h5>
                        <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                          {this.state.place.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body amenities">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          Amenities
                        </h5>
                        <MediaQuery minWidth={777}>
                          <div className="d-flex">
                            {this.state.amenities.map(function (chunk, index) {
                              return (
                                <div className="col-6" key={index}>
                                  <ul>
                                    {chunk.map(function (amenity) {
                                      return (
                                        <li key={amenity.id}>
                                          {amenity.description}
                                        </li>
                                      )
                                    })}
                                  </ul>
                                </div>
                              )
                            })}
                          </div>
                        </MediaQuery>

                        <MediaQuery maxWidth={776}>
                          <div className="col-12">
                            <ul>
                              {this.state.amenities.map(function (chunk) {
                                return chunk.map(function (amenity) {
                                  return (
                                    <li key={amenity.id}>
                                      {amenity.description}
                                    </li>
                                  )
                                })
                              })}
                            </ul>
                          </div>
                        </MediaQuery>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          Location
                        </h5>
                        <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                          {this.state.place.location_description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex">
                  <div className="col-12 col-md-6">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          Level of catering
                        </h5>
                        <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                          {this.state.place.catering}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          Preferred level of host / guest interaction
                        </h5>
                        <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                          {this.state.place.interaction}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex">
                  <div className="col-12 col-md-6">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          House rules
                        </h5>
                        <p className="card-text text-black font-open-sans font-weight-400">
                          <span className="font-size-14">
                            Are smokers welcome?
                          </span>{' '}
                          <br />
                          <span className="font-size-16">
                            {this.state.place.smoking}
                          </span>
                        </p>
                        <p className="card-text text-black font-open-sans font-weight-400">
                          <span className="font-size-14">
                            Can guests bring a pet?
                          </span>{' '}
                          <br />
                          <span className="font-size-16">
                            {this.state.place.pets}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="card card-grey border-0 mb-3 w-100">
                      <div className="card-body">
                        <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                          Tips for Guests
                        </h5>
                        <p className="card-text text-black font-open-sans font-weight-400">
                          <span className="font-size-14">
                            Do guests need their own car to get around?
                          </span>{' '}
                          <br />
                          <span className="font-size-16">
                            {this.state.place.transportation}
                          </span>
                        </p>
                        <p className="card-text text-black font-open-sans font-weight-400">
                          <span className="font-size-14">
                            Home accessible to people with disabilities?
                          </span>{' '}
                          <br />
                          <span className="font-size-16">
                            {this.state.place.accessibility}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.showMap && (
                  <div className="row">
                    <div className="col-12">
                      <MapComponent
                        isMarkerShown={this.state.isMarkerShown}
                        onMarkerClick={this.handleMarkerClick}
                        coordinates={this.state.coordinates}
                      />
                      <p className="text-black font-open-sans font-weight-600 font-size-14">
                        Exact address shared after booking
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <MediaQuery maxWidth={776}>
                {proceedToPayment && (
                  <div
                    className="container"
                    onClick={this.handleScrollToMobileBookingRequest}
                  >
                    <Button color="green" classes="w-100">
                      <span
                        className="w-100"
                        dangerouslySetInnerHTML={{
                          __html: `Pay ${this.state.place.currency}${(this.state.bookingForm.nights * +this.state.bookingRequest.fee).toFixed(2)} to confirm booking`,
                        }}
                      />
                    </Button>
                  </div>
                )}
              </MediaQuery>
              <MediaQuery minWidth={777}>
                <div className="col-12 col-md-4 mb-3">
                  <ResultUserCard
                    userPhoto={placeUser.photo}
                    userName={placeUser.forename}
                    location={this.state.place.location}
                    introduction={placeUser.introduction}
                    id={placeUser.id}
                  />
                  {proceedToPayment ? (
                    <BookingSectionConfirm
                      layout={'vertical'}
                      currency={this.state.place.currency}
                      bookingRequest={this.state.bookingRequest}
                      bookingForm={this.state.bookingForm}
                    />
                  ) : (
                    !IsPendingBookingRequest &&
                    !IsPendingVerificationBookingRequest && (
                      <BookingSection
                        ref={this.state.place.id}
                        place={this.state.place}
                        startDate={new Date()}
                        endDate={new Date()}
                        pickerDates={this.state.dates}
                        handleGuestChange={this.handleGuestChange}
                        handleMessageChange={this.handleMessageChange}
                        handleBookingRequest={this.handleBookingRequest}
                        scrollToRef={this.scrollToRef}
                        guests={this.state.guests}
                        customSelect={customSelect}
                        handleApply={this.handleApply}
                        nights={this.state.bookingForm.nights}
                        fee={this.state.bookingForm.fee}
                        bookingFormErrors={this.state.bookingFormErrors}
                        validateErrors={this.validateErrors}
                        modalStyles={modalStyles}
                      />
                    )
                  )}
                </div>
              </MediaQuery>
            </div>
          </div>
        </section>
        <VerifyModal
          isOpen={this.state.modalIsOpen}
          onClose={() =>  this.setState({
            modalIsOpen: false,
          })}
          variant="full"
          onVerify={() => {
            this.setState({
                modalIsOpen: false,
              })
            this.props.history.push('/myfreebird?s=vf');
          }}
          onCancel={() =>  this.setState({
            modalIsOpen: false,
          })}
        />
      </Fragment>
    )
  }
}

const ResultUserCard = ({
  userPhoto,
  id,
  userName,
  location,
  introduction,
}) => {
  return (
    <div className="card card-user card-outline-grey px-3 pt-3 mb-4">
      <div className="card-body">
        <div className="d-flex no-gutters mr-3">
          <div className="col-4 card-user-image-container">
            <div className="card-img-box">
              <img
                src={s3AwsEndpoint + '/' + userPhoto}
                onError={(e) => {
                  e.target.onError = null
                  e.target.src = '/images/listing/profile-coming-soon.png'
                }}
              />
            </div>
          </div>
          <MediaQuery minWidth={1024}>
            <div className="col-8 ml-3 pr-5">
              <div className="mb-4">
                <span className="font-all-round font-weight-600 font-size-20 text-black">
                  Meet your host
                </span>
              </div>
              <h5 className="card-title card-user-title m-0 w-100">
                <Link to={`/user/${id}`} className="font-size-20">
                  {userName}
                </Link>
              </h5>
              <p className="font-size-16 m-0">
                <img src="/images/icons/location.svg" alt="" /> {location}
              </p>
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={776}>
            <div className="col-8 ml-3 pr-5">
              <div className="mb-4">
                <span className="font-all-round font-weight-600 font-size-20 text-black">
                  Meet your host
                </span>
              </div>
              <h5 className="card-title card-user-title m-0 w-100">
                <Link to={`/user/${id}`} className="font-size-20">
                  {userName}
                </Link>
              </h5>
              <p className="font-size-16 m-0">
                <img src="/images/icons/location.svg" alt="" /> {location}
              </p>
            </div>
          </MediaQuery>
        </div>
        <div className="col-12">
          <div className="row">
            <MediaQuery minWidth={777} maxWidth={1024}>
              <div className="col-12">
                <div className="row">
                  <div className="mt-2 mb-4 w-100">
                    <div className="font-all-round font-weight-600 font-size-20 text-black">
                      Meet your host
                    </div>
                  </div>
                  <h5 className="card-title card-user-title m-0 w-100">
                    <Link to={`/user/${id}`} className="font-size-20">
                      {userName}
                    </Link>
                  </h5>
                  <p className="font-size-16 m-0">
                    <img src="/images/icons/location.svg" alt="" /> {location}
                  </p>
                </div>
              </div>
            </MediaQuery>
            <div className="card-introduction mt-3">
              <div className="no-gutters">
                <MediaQuery minWidth={1160}>
                  <span className="font-size-15">
                    {strLimit(introduction, 170)}
                  </span>
                </MediaQuery>
                <MediaQuery minWidth={960} maxWidth={1159}>
                  <span className="font-size-15">
                    {strLimit(introduction, 140)}
                  </span>
                </MediaQuery>
                <MediaQuery minWidth={768} maxWidth={959}>
                  <span className="font-size-15">
                    {strLimit(introduction, 110)}
                  </span>
                </MediaQuery>
                <MediaQuery maxWidth={767}>
                  <span className="font-size-15">
                    {strLimit(introduction, 200)}
                  </span>
                </MediaQuery>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withSearch(withAuth(Place))
